<template>
    <div>
        <div class="el-table el-table--fit el-table--border inner-table" style="border-top: none !important; border-left: none !important">
            <div class="el-table__body-wrapper">
                <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                    <tbody>
                        <tr>
                            <td colspan="6" style="position: relative">
                                <span style="display: inline-block; margin-left: 45%; color: #333333; font-weight: bold">结果公告信息</span>
                                <el-button v-if="canEdit == 1 && vo.ggType == 1" style="position: absolute; right: 5px" @click="add()">添加标包</el-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <el-form :model="vo" class="el-form wflow-busiform">
            <div class="el-table el-table--fit el-table--border" style="border-top: none !important; border-left: none !important">
                <div class="el-table__body-wrapper">
                    <table cellspacing="0" cellpadding="0" border="0" class="el-table__body listTable">
                        <tbody>
                            <!-- <tr>
                                <td colspan="6" style="position: relative;">
                                    <span style="display: inline-block;margin-left: 45%;color: #333333; font-weight: bold">结果公告信息</span>
                                    <el-button v-if="canEdit==1&&vo.ggType==1" style="position: absolute;right: 5px;" @click="add()">添加标包</el-button>
                                </td>
                            </tr> -->
                            <tr>
                                <td id="tdw17" ref="tdlbl_项目名称" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'flSubject'" class="field">发布日期</span>
                                </td>
                                <td v-if="vo.jgPublicDate == null || vo.jgPublicDate" class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="jgPublicDate"
                                        :field="{ defaultValue: null, elementCanEdit: '{${curTN.tnCanEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 1, elementType: 'date', emptyMessage: '请选择发布日期', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '发布日期', propName: 'jgPublicDate', propType: 'java.util.Date', textFormatter: 'yyyy-MM-dd HH:mm', valueMaxLength: null, valueMinLength: null, model: 'vo.jgPublicDate', option: [] }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td v-else class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="publicDate"
                                        :field="{ defaultValue: null, elementCanEdit: '{${curTN.tnCanEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 1, elementType: 'date', emptyMessage: '请选择发布日期', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '发布日期', propName: 'publicDate', propType: 'java.util.Date', textFormatter: 'yyyy-MM-dd HH:mm', valueMaxLength: null, valueMinLength: null, model: 'vo.publicDate', option: [] }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                                <td ref="tdlbl_项目名称" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'flSubject'" class="field">公告类型</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
                                    <form-item
                                        ref="ggType"
                                        :field="{
                                            defaultValue: null,
                                            elementCanEdit: '{${curTN.tnCanEdit}}',
                                            elementCssHeight: null,
                                            elementCssWidth: null,
                                            elementFormatter: '1：中标/成交\n2：流标/终止',
                                            elementReadonly: 1,
                                            elementType: 'radio',
                                            emptyMessage: '请选择公告类型',
                                            errorMessage: null,
                                            formTdAlign: 'text-left',
                                            formTdColspan: 0,
                                            isRequired: 1,
                                            onClickEvent: null,
                                            passenger: {},
                                            propComment: '公告类型',
                                            propName: 'ggType',
                                            propType: 'Short',
                                            textFormatter: null,
                                            valueMaxLength: null,
                                            valueMinLength: null,
                                            model: 'vo.ggType',
                                            option: [
                                                { value: '1', name: '中标/成交' },
                                                { value: '2', name: '流标/终止' }
                                            ],
                                            optionGenerateType: 0,
                                            clearable: false,
                                            filterable: false,
                                            allowCreate: false,
                                            remoteMethod: ''
                                        }"
                                        :vo="vo"
                                        :can-edit="canEdit"
                                    />
                                </td>
                            </tr>
                            <template v-if="vo.ggType == 1">
                                <tr>
                                    <td ref="tdlbl_总中标/成交金额" class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'zzbAmount'" class="field">总中标/成交金额</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                        <form-item
                                            ref="zbAmount"
                                            :field="{
                                                defaultValue: null,
                                                elementCanEdit: '{${curTN.tnCanEdit}}',
                                                elementCssHeight: null,
                                                elementCssWidth: null,
                                                elementFormatter: null,
                                                elementReadonly: 0,
                                                elementType: 'input',
                                                emptyMessage: '请输入总中标/成交金额',
                                                errorMessage: null,
                                                formTdAlign: 'text-left',
                                                formTdColspan: 0,
                                                isRequired: 1,
                                                onClickEvent: '@change=computeAmount',
                                                passenger: {},
                                                propComment: '总中标/成交金额（元）',
                                                propName: 'zzbAmount',
                                                propType: 'java.math.BigDecimal',
                                                textFormatter: 'currency2',
                                                valueMaxLength: null,
                                                valueMinLength: null,
                                                model: 'vo.zzbAmount',
                                                option: [],
                                                autocomplete: 'off',
                                                dialog: 0,
                                                showWordLimit: false
                                            }"
                                            :vo="vo"
                                            :can-edit="canEdit"
                                        />
                                        <!-- <form-item ref="zzbAmount" :field="{'defaultValue':null,'elementCanEdit':'{${curTN.tnCanEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入总中标/成交金额（元）','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'总中标/成交金额','propName':'zzbAmount','propType':'java.math.BigDecimal','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.zzbAmount','option':[],'autocomplete':'off','dialog':0,'showWordLimit':false}" :vo="vo" :can-edit="canEdit" /> -->
                                    </td>
                                    <td ref="tdlbl_总代理费金额" class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'agentAmount'" class="field">总代理费金额</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                        <form-item
                                            ref="zbAmount"
                                            :field="{
                                                defaultValue: null,
                                                elementCanEdit: '{${curTN.tnCanEdit}}',
                                                elementCssHeight: null,
                                                elementCssWidth: null,
                                                elementFormatter: null,
                                                elementReadonly: 0,
                                                elementType: 'input',
                                                emptyMessage: '请输入总代理费金额',
                                                errorMessage: null,
                                                formTdAlign: 'text-left',
                                                formTdColspan: 0,
                                                isRequired: 1,
                                                onClickEvent: '@change=computeAmount',
                                                passenger: {},
                                                propComment: '总代理费金额（元）',
                                                propName: 'agentAmount',
                                                propType: 'java.math.BigDecimal',
                                                textFormatter: 'currency2',
                                                valueMaxLength: null,
                                                valueMinLength: null,
                                                model: 'vo.agentAmount',
                                                option: [],
                                                autocomplete: 'off',
                                                dialog: 0,
                                                showWordLimit: false
                                            }"
                                            :vo="vo"
                                            :can-edit="canEdit"
                                        />
                                    </td>
                                </tr>
                                <template v-for="(item, index) in vo.passenger.jgItemList">
                                    <tr :key="index + '-index'">
                                        <td class="el-table__cell tdcont tdw83" colspan="6">
                                            <span>标包信息{{ index + 1 }}</span>
                                            <el-button v-if="canEdit == 1" style="position: absolute; right: 5px; color: #f67f6c" type="text" @click="deleteBb(index)">删除标包</el-button>
                                        </td>
                                    </tr>
                                    <tr :key="index + '-first'">
                                        <td ref="tdlbl_标包号" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'flSubject'" class="field">标包号</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw33" colspan="5">
                                            <form-item
                                                ref="contactPerson"
                                                :field="{
                                                    defaultValue: null,
                                                    elementCanEdit: '{${curTN.tnCanEdit}}',
                                                    elementCssHeight: null,
                                                    elementCssWidth: null,
                                                    elementFormatter: null,
                                                    elementReadonly: 0,
                                                    elementType: 'input',
                                                    emptyMessage: '请输入标包号',
                                                    errorMessage: null,
                                                    formTdAlign: 'text-left',
                                                    formTdColspan: 0,
                                                    isRequired: 1,
                                                    onClickEvent: null,
                                                    passenger: {},
                                                    propComment: '标包号',
                                                    propName: 'section',
                                                    propType: 'String',
                                                    textFormatter: 'textfield',
                                                    valueMaxLength: null,
                                                    valueMinLength: null,
                                                    model: 'item.section',
                                                    option: [],
                                                    autocomplete: 'off',
                                                    dialog: 0,
                                                    showWordLimit: false
                                                }"
                                                :vo="item"
                                                :can-edit="canEdit"
                                            />
                                        </td>
                                    </tr>
                                    <tr :key="index + '-second'">
                                        <td ref="tdlbl_标包文件获取人数" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'flSubject'" class="field">标包文件获取人数</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw33" colspan="2">
                                            <form-item
                                                ref="contactPerson"
                                                :field="{
                                                    defaultValue: null,
                                                    elementCanEdit: '{${curTN.tnCanEdit}}',
                                                    elementCssHeight: null,
                                                    elementCssWidth: null,
                                                    elementFormatter: null,
                                                    elementReadonly: 0,
                                                    elementType: 'input',
                                                    emptyMessage: '请输入标包文件获取人数',
                                                    errorMessage: null,
                                                    formTdAlign: 'text-left',
                                                    formTdColspan: 0,
                                                    isRequired: 1,
                                                    onClickEvent: null,
                                                    passenger: {},
                                                    propComment: '标包文件获取人数',
                                                    propName: 'fileGetCount',
                                                    propType: 'String',
                                                    textFormatter: 'textfield',
                                                    valueMaxLength: null,
                                                    valueMinLength: null,
                                                    model: 'item.fileGetCount',
                                                    option: [],
                                                    autocomplete: 'off',
                                                    dialog: 0,
                                                    showWordLimit: false
                                                }"
                                                :vo="item"
                                                :can-edit="canEdit"
                                            />
                                        </td>
                                        <td ref="tdlbl_标包投标/响应人数" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'flSubject'" class="field">标包投标/响应人数</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw33" colspan="2">
                                            <form-item
                                                ref="contactPerson"
                                                :field="{
                                                    defaultValue: null,
                                                    elementCanEdit: '{${curTN.tnCanEdit}}',
                                                    elementCssHeight: null,
                                                    elementCssWidth: null,
                                                    elementFormatter: null,
                                                    elementReadonly: 0,
                                                    elementType: 'input',
                                                    emptyMessage: '请输入标包投标/响应人数',
                                                    errorMessage: null,
                                                    formTdAlign: 'text-left',
                                                    formTdColspan: 0,
                                                    isRequired: 1,
                                                    onClickEvent: null,
                                                    passenger: {},
                                                    propComment: '标包投标/响应人数',
                                                    propName: 'responseCount',
                                                    propType: 'String',
                                                    textFormatter: 'textfield',
                                                    valueMaxLength: null,
                                                    valueMinLength: null,
                                                    model: 'item.responseCount',
                                                    option: [],
                                                    autocomplete: 'off',
                                                    dialog: 0,
                                                    showWordLimit: false
                                                }"
                                                :vo="item"
                                                :can-edit="canEdit"
                                            />
                                        </td>
                                    </tr>
                                    <tr :key="index + '-third'">
                                        <td ref="tdlbl_标包中标人名称" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'flSubject'" class="field">标包中标人名称</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw33" colspan="5">
                                            <form-item
                                                ref="contactPerson"
                                                :field="{
                                                    defaultValue: null,
                                                    elementCanEdit: '{${curTN.tnCanEdit}}',
                                                    elementCssHeight: null,
                                                    elementCssWidth: null,
                                                    elementFormatter: null,
                                                    elementReadonly: 0,
                                                    elementType: 'input',
                                                    emptyMessage: '请输入标包中标人名称',
                                                    errorMessage: null,
                                                    formTdAlign: 'text-left',
                                                    formTdColspan: 0,
                                                    isRequired: 1,
                                                    onClickEvent: null,
                                                    passenger: {},
                                                    propComment: '标包中标人名称',
                                                    propName: 'supplier',
                                                    propType: 'String',
                                                    textFormatter: 'textfield',
                                                    valueMaxLength: null,
                                                    valueMinLength: null,
                                                    model: 'item.supplier',
                                                    option: [],
                                                    autocomplete: 'off',
                                                    dialog: 0,
                                                    showWordLimit: false
                                                }"
                                                :vo="item"
                                                :can-edit="canEdit"
                                            />
                                        </td>
                                    </tr>
                                    <tr :key="index + '-fourth'">
                                        <td ref="tdlbl_标包文件获取人数" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'flSubject'" class="field">标包中标/成交金额</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw33" colspan="2">
                                            <form-item
                                                ref="zbAmount"
                                                :field="{
                                                    defaultValue: null,
                                                    elementCanEdit: '{${curTN.tnCanEdit}}',
                                                    elementCssHeight: null,
                                                    elementCssWidth: null,
                                                    elementFormatter: null,
                                                    elementReadonly: 0,
                                                    elementType: 'input',
                                                    emptyMessage: '请输入标包中标/成交金额',
                                                    errorMessage: null,
                                                    formTdAlign: 'text-left',
                                                    formTdColspan: 0,
                                                    isRequired: 1,
                                                    onClickEvent: null,
                                                    passenger: {},
                                                    propComment: '预算金额（元）',
                                                    propName: 'zbAmount',
                                                    propType: 'java.math.BigDecimal',
                                                    textFormatter: 'currency2',
                                                    valueMaxLength: null,
                                                    valueMinLength: null,
                                                    model: 'item.zbAmount',
                                                    option: [],
                                                    autocomplete: 'off',
                                                    dialog: 0,
                                                    showWordLimit: false
                                                }"
                                                :vo="item"
                                                :can-edit="canEdit"
                                            />
                                            <!-- <form-item ref="contactPerson" :field="{'defaultValue':null,'elementCanEdit':'{${curTN.tnCanEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入标包中标/成交金额','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'标包中标/成交金额','propName':'zbAmount','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'item.zbAmount','option':[],'autocomplete':'off','dialog':0,'showWordLimit':false}" :vo="item" :can-edit="canEdit" /> -->
                                        </td>
                                        <td ref="tdlbl_代理费金额" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="required">*</span>
                                            <span v-field-lbl="'flSubject'" class="field">代理费金额</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw33" colspan="2">
                                            <form-item
                                                ref="agentAmount"
                                                :field="{
                                                    defaultValue: null,
                                                    elementCanEdit: '{${curTN.tnCanEdit}}',
                                                    elementCssHeight: null,
                                                    elementCssWidth: null,
                                                    elementFormatter: null,
                                                    elementReadonly: 0,
                                                    elementType: 'input',
                                                    emptyMessage: '请输入代理费金额',
                                                    errorMessage: null,
                                                    formTdAlign: 'text-left',
                                                    formTdColspan: 0,
                                                    isRequired: 1,
                                                    onClickEvent: null,
                                                    passenger: {},
                                                    propComment: '代理费金额（元）',
                                                    propName: 'agentAmount',
                                                    propType: 'java.math.BigDecimal',
                                                    textFormatter: 'currency2',
                                                    valueMaxLength: null,
                                                    valueMinLength: null,
                                                    model: 'item.agentAmount',
                                                    option: [],
                                                    autocomplete: 'off',
                                                    dialog: 0,
                                                    showWordLimit: false
                                                }"
                                                :vo="item"
                                                :can-edit="canEdit"
                                            />
                                        </td>
                                    </tr>
                                </template>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 },
        module: { type: String, default: null },
        baseUrl: { type: String, default: null },
        listName: { type: String, default: null },
        isHttp: { type: Boolean, default: true }
    },
    data() {
        return {
            moduleInfo: {}
        }
    },
    computed: {},
    watch: {
        'vo.passenger.jgItemList': {
            handler: function (newValue, oldValue) {
                this.computeAmount()
            },
            deep: true
        }
    },
    created() {},
    beforeDestroy() {},
    mounted() {},
    methods: {
        computeAmount() {
            debugger
            let zbAmount = 0.0
            let agentAmount = 0.0
            this.vo.passenger.jgItemList.forEach((item) => {
                zbAmount += parseFloat(item.zbAmount) || 0
                agentAmount += parseFloat(item.agentAmount) || 0
            })

            this.$set(this.vo, 'zzbAmount', zbAmount)
            this.$set(this.vo, 'agentAmount', agentAmount)
        },
        add() {
            this.vo.passenger.jgItemList.push({
                agentAmount: '',
                zbAmount: '',
                supplier: '',
                responseCount: '',
                fileGetCount: '',
                section: ''
            })
        },
        deleteBb(index) {
            this.vo.passenger.jgItemList.splice(index, 1)
        }
    }
}
</script>

<style scoped lang="scss"></style>
